export const uk = {
    'archived-experiment-name': 'Эксперимент {experimentId}'
};
